/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  defaultCurrencyFormat,
  formatDate,
  formatDateTime,
  strictValidArrayWithLength,
  strictValidNumber,
  strictValidObjectWithKeys,
  strictValidString,
} from "../../../utils/common-utils";
import ReactTable from "../../../components/react-table";
import {
  getCorporateAccounts,
  getExcelInvoiceReport,
  getInvoiceReportList,
} from "../action";
import DownloadIcon from "@mui/icons-material/Download";
import { makeStyles } from "@mui/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MdDatePicker from "../../../components/mdDatePicker";
import Dialog from "../../../components/dialog";
import { Box } from "@mui/system";
import CellTypes from "../../../components/react-table/components/renderTypes";
const apiHost = process.env.REACT_APP_BASE_URL;
const useStyles = makeStyles(() => ({
  input: {
    width: "10%",
    backgroundColor: "#FAFAFA",
    fontSize: 14,
  },
  button: {
    width: "10%",
  },
}));

const InvoiceReport = ({
  isLoad,
  isLoadInner,
  total_invoice,
  callInvoicingApi,
  callCorporateAccountBilling,
  callExcelFromAccountApi,
  corporateAccountFromState,
  invoice_data,
}) => {
  const classes = useStyles();
  const [total, changeTotal] = useState(total_invoice);
  const [search, setSearch] = useState("");
  const [extraDialog, setExtraDialog] = useState(false);
  const [extraCharges, setExtraCharges] = useState([]);
  const [choose_account, setChooseAccount] = useState("");
  const [new_account_id, setNewAccountID] = useState("");
  const [state, setState] = useState({
    account_id: "",
    start_date: null,
    end_date: null,
    sub_account_id: "",
    invoice_status: "",
  });

  const [pagination, changePagination] = useState({
    total: 0,
    recordsPerPage: null,
    pageIndex: 0,
    currentPage: 1,
  });
  const { account_id, sub_account_id, start_date, end_date, invoice_status } =
    state;
  const [corporate_account, setCorporateAccountApi] = useState([]);

  useEffect(() => {
    callCorporateAccountBilling();
  }, []);

  useEffect(() => {
    if (pagination.recordsPerPage) {
      callInvoicingApi({
        ...state,
        account_id:
          account_id && !sub_account_id
            ? account_id
            : !account_id && sub_account_id
            ? new_account_id
            : "all",
        invoice_status: invoice_status ? invoice_status : "all",
        limit: pagination.recordsPerPage,
        skip: pagination.pageIndex * pagination.recordsPerPage,
        search: search,
      });
    }
  }, []);

  useEffect(() => {
    changeTotal(total_invoice);
  }, [total_invoice]);

  const setRecordsPerPage = (size) => {
    changePagination({
      ...pagination,
      recordsPerPage: size,
    });
    callInvoicingApi({
      ...state,
      account_id:
        account_id && !sub_account_id
          ? account_id
          : !account_id && sub_account_id
          ? new_account_id
          : "all",
      invoice_status: invoice_status ? invoice_status : "all",
      limit: size,
      skip: pagination.pageIndex * size,
      search: search,
    });
  };

  const changePageSize = (pageSize) => {
    changePagination({
      ...pagination,
      recordsPerPage: pageSize,
      pageIndex: 0,
    });
    callInvoicingApi({
      ...state,
      account_id:
        account_id && !sub_account_id
          ? account_id
          : !account_id && sub_account_id
          ? new_account_id
          : "all",
      invoice_status: invoice_status ? invoice_status : "all",
      limit: pageSize,
      skip: 0,
      search: search,
    });
  };

  const changePageIndex = (pageIndex) => {
    changePagination({
      ...pagination,
      pageIndex: pageIndex,
    });
    callInvoicingApi({
      ...state,
      account_id:
        account_id && !sub_account_id
          ? account_id
          : !account_id && sub_account_id
          ? new_account_id
          : "all",
      invoice_status: invoice_status ? invoice_status : "all",
      limit: pagination.recordsPerPage,
      skip: pageIndex * pagination.recordsPerPage,
      search: search,
    });
  };
  useEffect(() => {
    const corporateAccountArray = [];
    if (strictValidArrayWithLength(corporateAccountFromState)) {
      corporateAccountFromState.map((a) => {
        return corporateAccountArray.push({
          value: a.account_id,
          title: a.name,
          sub_account_id: a.sub_account_id,
        });
      });
    }
    setCorporateAccountApi(corporateAccountArray);
  }, [corporateAccountFromState]);

  const downloadFile = (val) => {
    window.open(val);
  };

  const downloadExcelFile = async (
    account_id,
    sub_account_id,
    start_date,
    end_date,
    search,
    invoice_status
  ) => {
    let response = await callExcelFromAccountApi({
      account_id:
        account_id && !sub_account_id
          ? account_id
          : !account_id && sub_account_id
          ? new_account_id
          : "all",
      sub_account_id: sub_account_id,
      start_date: start_date,
      end_date: end_date,
      search: search,
      invoice_status: invoice_status ? invoice_status : "all",
      account_field: "true",
    });
    if (response) {
      downloadFile(`${apiHost}${response}`);
    }
  };

  const renderStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "locked":
        return "Locked";
      case "send_invoiced":
        return "Sent";
      case "part_paid":
        return "Part Paid";
      case "fully_paid":
        return "Fully Paid";
      default:
        return "";
    }
  };

  const invoiceList = [
    {
      value: "locked",
      title: "Locked",
    },
    { value: "send_invoiced", title: "Sent" },
    { value: "part_paid", title: "Part Paid" },
    { value: "fully_paid", title: "Fully Paid" },
  ];

  const infoToggle = () => {
    setExtraDialog(!extraDialog);
  };

  const extraChargesDialog = () => {
    return (
      <Dialog
        fullScreen={false}
        isOpen={extraDialog}
        fullWidth={false}
        maxWidth={"md"}
        sxAppBar={{ justifyContent: "center" }}
        sxTitle={{ fontSize: 24, textAlign: "center" }}
        closeIcon={true}
        title={"Extra Charges"}
        handleClose={() => {
          infoToggle();
        }}
      >
        <DialogContent
          sx={{
            overflow: "auto",
            // height: "200px",
            maxHeight: "500px",
            minHeight: "200px",
            width: "700px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Box>
            <ReactTable
              globalFilterShow={false}
              customHeight={true}
              headerFilter={false}
              tableSize={true}
              height={{
                maxHeight: "40vh",
                minHeight: "20vh",
              }}
              loading={false}
              pagination={false}
              customText="No Feedbacks Found"
              columnDefs={[
                {
                  Header: "Service Name",
                  accessor: "label",
                  width: 300,
                  disableSortBy: true,
                  Cell: (props) => (
                    <Stack>
                      <Typography>{props.row.original.label}</Typography>
                    </Stack>
                  ),
                },
                {
                  Header: "Charges",
                  accessor: (originalRow, rowIndex) => {
                    return (
                      strictValidObjectWithKeys(originalRow) &&
                      originalRow.amount
                    );
                  },
                  width: 200,
                  disableSortBy: true,
                  Cell: (props) => (
                    <Stack>
                      <Typography>
                        {defaultCurrencyFormat(props.row.original.amount)}
                      </Typography>
                    </Stack>
                  ),
                },
              ]}
              rowData={extraCharges}
            />
          </Box>
        </DialogContent>
        <DialogActions
          sx={{ justifyContent: "center", display: "flex", mt: 2 }}
        >
          <Button
            className={classes.buttonForceAction}
            color="error"
            variant="outlined"
            onClick={() => infoToggle()}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const AccountFilters = () => {
    // Render a multi-select box
    return (
      <FormControl className={classes.input} size="small" variant="outlined">
        <InputLabel id="demo-simple-select-helper-label">
          Select Corporate Account
        </InputLabel>
        <Select
          defaultValue=""
          labelId="demo-simple-select-helper-label"
          id="select_corporate_account"
          value={choose_account}
          label="Select Corporate Account"
          onChange={(e) => {
            const string = e.target.value;
            const values =
              string === "all"
                ? "all"
                : strictValidString(string) && string.split(",");
            const secondValue =
              string === "all"
                ? ""
                : strictValidArrayWithLength(values) && values[1].trim();
            if (strictValidString(values[0])) {
              setNewAccountID(values[0]);
            } else {
              setNewAccountID("");
            }
            setChooseAccount(e.target.value);
            setState((prevState) => ({
              ...prevState,
              sub_account_id:
                typeof e.target.value === "string"
                  ? secondValue?.replace("sub- ", "")
                  : "",
              account_id:
                typeof e.target.value === "string" && e.target.value !== "all"
                  ? null
                  : string,
            }));
          }}
        >
          <MenuItem value={"all"}>All</MenuItem>
          {strictValidArrayWithLength(corporate_account) &&
            corporate_account.map((option, i) => (
              <MenuItem
                sx={{ textTransform: "capitalize" }}
                key={i}
                value={
                  option.sub_account_id
                    ? `${option.value},${option.sub_account_id}`
                    : option.value
                }
              >
                {option.title}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  };

  const DateFilterStartDate = (updateVal, value, label) => {
    const handleChange = (newValue) => {
      if (newValue === null) {
        setState((prevState) => ({
          ...prevState,
          [updateVal]: null,
          end_date: null,
        }));
      } else {
        const d = formatDate(newValue);

        setState((prevState) => {
          const newState = { ...prevState, [updateVal]: d };

          if (strictValidString(prevState.end_date)) {
            const start = new Date(d);
            const end = new Date(prevState.end_date);
            const maxEnd = new Date(start);
            maxEnd.setDate(start.getDate() + 30);
            if (end < start || end > maxEnd) {
              newState.end_date = null;
            }
          }

          return newState;
        });
      }
    };

    return (
      <MdDatePicker
        name={value}
        id="unit_add_start_time"
        value={value}
        required={true}
        placeholder={label}
        type="onlydate-small"
        onAccept={handleChange}
        onChange={(w) => handleChange(w)}
        compareTime={false}
        onSave={() => {}}
        closeOnSelect
      />
    );
  };

  const DateFilterEndDate = (updateVal, value, label) => {
    const handleChange = (newValue) => {
      if (newValue === null) {
        setState((prevState) => ({
          ...prevState,
          [updateVal]: null,
        }));
      } else {
        const d = formatDate(newValue);
        setState((prevState) => ({
          ...prevState,
          [updateVal]: d,
        }));
      }
    };

    const getMaxEndDate = () => {
      if (strictValidString(start_date)) {
        const start = new Date(start_date);
        const maxEnd = new Date(start);
        maxEnd.setDate(start.getDate() + 30);
        return maxEnd;
      }
      return null;
    };

    return (
      <MdDatePicker
        name={value}
        id="unit_add_end_time"
        value={value}
        placeholder={label}
        required={true}
        type="onlydate-small"
        onAccept={handleChange}
        onChange={(w) => handleChange(w)}
        compareTime={false}
        minDate={strictValidString(start_date) ? new Date(start_date) : null}
        maxDate={getMaxEndDate()}
        onSave={() => {}}
        closeOnSelect
      />
    );
  };

  const invoiceStatusFilter = () => {
    return (
      <>
        <FormControl className={classes.input} size="small" variant="outlined">
          <InputLabel id="demo-simple-select-label">
            Select Invoice Status
          </InputLabel>
          <Select
            defaultValue=""
            labelId="demo-simple-select-helper-label"
            id="select_corporate_account"
            value={state?.invoice_status}
            label="Select Invoice Status"
            onChange={(e) => {
              setState({
                ...state,
                invoice_status: e.target.value,
              });
            }}
          >
            <MenuItem value={"all"}>All</MenuItem>
            {strictValidArrayWithLength(invoiceList) &&
              invoiceList?.map((option, i) => (
                <MenuItem
                  sx={{ textTransform: "capitalize" }}
                  key={i}
                  value={option.value}
                >
                  {option.title}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </>
    );
  };

  const searchQueryFilter = (e) => {
    callInvoicingApi({
      ...state,
      account_id:
        account_id && !sub_account_id
          ? account_id
          : !account_id && sub_account_id
          ? new_account_id
          : "all",
      invoice_status: invoice_status ? invoice_status : "all",
      limit: pagination.recordsPerPage,
      skip: 0,
      search: e,
    });
    changePagination({
      ...pagination,
      recordsPerPage: pagination.recordsPerPage,
      pageIndex: 0,
    });
    setSearch(e);
  };
  const clearQueryFilter = (text) => {
    setChooseAccount("");
    setState({
      start_date: null,
      end_date: null,
      account_id: "",
      sub_account_id: "",
      invoice_status: "",
    });
    setNewAccountID("");
    callInvoicingApi({
      ...state,
      start_date: null,
      end_date: null,
      account_id:
        account_id && !sub_account_id
          ? account_id
          : !account_id && sub_account_id
          ? new_account_id
          : "all",
      invoice_status: invoice_status ? invoice_status : "all",
      sub_account_id: "",
      limit: pagination.recordsPerPage,
      skip: 0,
      search: text,
    });
    changePagination({
      ...pagination,
      recordsPerPage: pagination.recordsPerPage,
      pageIndex: 0,
    });
    setSearch(text);
  };

  const checkValidStringInObject = (transport_data) => {
    if (
      strictValidString(transport_data.start_date) &&
      strictValidString(transport_data.end_date)
    ) {
      return false;
    } else if (
      strictValidString(transport_data.sub_account_id) &&
      strictValidString(transport_data.start_date) &&
      strictValidString(transport_data.end_date)
    ) {
      return false;
    } else if (
      strictValidNumber(transport_data.account_id) &&
      strictValidString(transport_data.start_date) &&
      strictValidString(transport_data.end_date)
    ) {
      return false;
    } else if (
      transport_data.account_id === "all" &&
      strictValidString(transport_data.start_date) &&
      strictValidString(transport_data.end_date)
    ) {
      return false;
    } else if (
      strictValidString(transport_data.invoice_status) &&
      strictValidString(transport_data.start_date) &&
      strictValidString(transport_data.end_date)
    ) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      <Grid>
        <Stack mt={2} direction="row" spacing={2}>
          {AccountFilters()}
          {DateFilterStartDate("start_date", start_date, "Start Date")}
          {DateFilterEndDate("end_date", end_date, "End Date")}
          {invoiceStatusFilter()}
          <Button
            variant="contained"
            disabled={checkValidStringInObject(state)}
            onClick={() => {
              callInvoicingApi({
                ...state,
                account_id:
                  account_id && !sub_account_id
                    ? account_id
                    : !account_id && sub_account_id
                    ? new_account_id
                    : "all",
                invoice_status: invoice_status ? invoice_status : "all",
                limit: pagination.recordsPerPage,
                skip: pagination.pageIndex * pagination.recordsPerPage,
                search: search,
              });
            }}
          >
            Get Report
          </Button>
          <Button
            variant="contained"
            disabled={checkValidStringInObject(state)}
            onClick={() => {
              setChooseAccount("");
              setState({
                start_date: null,
                end_date: null,
                account_id: "",
                sub_account_id: "",
                invoice_status: "",
              });
              setNewAccountID("");
              callInvoicingApi({
                start_date: null,
                end_date: null,
                sub_account_id: "",
                account_id: "all",
                invoice_status: "all",
                limit: pagination.recordsPerPage,
                skip: 0,
                search: "",
              });
            }}
          >
            Clear Filters
          </Button>
          <Button
            startIcon={<DownloadIcon />}
            variant="contained"
            disabled={!strictValidArrayWithLength(invoice_data)}
            onClick={() =>
              downloadExcelFile(
                account_id,
                sub_account_id,
                start_date,
                end_date,
                search,
                invoice_status
              )
            }
          >
            Download Report
          </Button>
        </Stack>
        <ReactTable
          loading={isLoad}
          isLoadInner={isLoadInner}
          DateFilterCss={true}
          customText={"You do not have any Invoice Reports"}
          serverSideFilter={(e) => searchQueryFilter(e)}
          serverSidePagination={true}
          clearFilterButton={() => {
            clearQueryFilter("");
          }}
          headerFilter={false}
          recordsPerPage={pagination.recordsPerPage}
          setRecordsPerPage={setRecordsPerPage}
          pageNumber={pagination.pageIndex}
          total={total}
          changePageSize={changePageSize}
          changePageIndex={changePageIndex}
          columnDefs={[
            {
              Header: "Account",
              accessor: "account_name",
              Cell: (props) => (
                <Stack>
                  <Tooltip title={props.row.original?.account_name}>
                    <Typography>{props.row.original?.account_name}</Typography>
                  </Tooltip>
                </Stack>
              ),
              width: 100,
              disableSortBy: true,
            },
            {
              Header: "Invoice Id",
              accessor: "invoice_id",
              width: 65,
              disableSortBy: true,
            },
            {
              Header: "Leg ID",
              accessor: "leg_id",
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "Pick-up Time",
              accessor: (originalRow) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  originalRow.pick_up_date_time
                );
              },
              width: 95,
              disableSortBy: true,
            }, 
            {
              Header: "Invoice Date",
              accessor: "invoice_date",
              width: 85,
              disableSortBy: true,
            },
            {
              Header: "Invoice Status",
              accessor: "invoice_status",
              Cell: (props) => (
                <Stack>
                  <Tooltip
                    title={renderStatus(props.row.original?.invoice_status)}
                  >
                    <Typography>
                      {renderStatus(props.row.original?.invoice_status)}
                    </Typography>
                  </Tooltip>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "Completion Charges",
              width: 90,
              disableSortBy: true,
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.completion_charge)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.completion_charge
                    )}
                  </Typography>
                </Stack>
              ),
            },
            {
              Header: "Capability",
              accessor: "capability_id",
              width: 150,
              disableSortBy: true,
              Cell: (props) => (
                <>
                  <CellTypes
                    type="capability_role"
                    value={props.row.original?.capability_id?.toString()}
                  />
                </>
              ),
            },
            {
              Header: "Capability Charge",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.capability_price)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.capability_price
                    )}
                  </Typography>
                </Stack>
              ),
              width: 85,
              disableSortBy: true,
            },
            {
              Header: "Milage Charges",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(
                    originalRow?.cal_billing_charge_mileage_per_mile
                  )
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.cal_billing_charge_mileage_per_mile
                    )}
                  </Typography>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "Value Partner Discount",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(
                    originalRow?.cal_value_partner_discount
                  )
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.cal_value_partner_discount
                    )}
                  </Typography>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "Oxygen",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.cal_billing_oxygen)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.cal_billing_oxygen
                    )}
                  </Typography>
                </Stack>
              ),
              width: 70,
              disableSortBy: true,
            },
            {
              Header: "Need WC",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.cal_need_wc)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(props.row.original?.cal_need_wc)}
                  </Typography>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "PU Stairs",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.cal_charge_stairs_pu)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.cal_charge_stairs_pu
                    )}
                  </Typography>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "DO Stairs",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.cal_charge_stairs_du)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.cal_charge_stairs_du
                    )}
                  </Typography>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "PU Wait Time",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.wait_time_pu)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(props.row.original?.wait_time_pu)}
                  </Typography>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "DO Wait Time",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.wait_time_do)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(props.row.original?.wait_time_do)}
                  </Typography>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "Out of Service Charge",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.out_of_service_area)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.out_of_service_area
                    )}
                  </Typography>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "Waiting Time",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.cal_waiting_time)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.cal_waiting_time
                    )}
                  </Typography>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "OOT Per Miles",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.charge_OOT_per_mile)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.charge_OOT_per_mile
                    )}
                  </Typography>
                </Stack>
              ),
              width: 80,
              disableSortBy: true,
            },
            {
              Header: "Holiday Overnight Surcharge",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(
                    originalRow?.holidays_overnight_surcharge
                  )
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.holidays_overnight_surcharge
                    )}
                  </Typography>
                </Stack>
              ),
              width: 100,
              disableSortBy: true,
            },
            {
              Header: "Dual Stretcher Charges",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.dual_stretcher_charge)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.dual_stretcher_charge
                    )}
                  </Typography>
                </Stack>
              ),
              width: 100,
              disableSortBy: true,
            },
            {
              Header: "Fuel Charges",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.fuel_charge)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(props.row.original?.fuel_charge)}
                  </Typography>
                </Stack>
              ),
              width: 80,
              disableSortBy: true,
            },
            {
              Header: "Total",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.total)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(props.row.original?.total)}
                  </Typography>
                </Stack>
              ),
              width: 70,
              disableSortBy: true,
            },
            {
              Header: "Discount (%)",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.discount)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>{props.row.original?.discount + "%"}</Typography>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "Discount Amount",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.discount_amount)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(props.row.original?.discount_amount)}
                  </Typography>
                </Stack>
              ),
              width: 85,
              disableSortBy: true,
            },
            {
              Header: "Sub Total",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.subtotal_after_discount)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(
                      props.row.original?.subtotal_after_discount
                    )}
                  </Typography>
                </Stack>
              ),
              width: 90,
              disableSortBy: true,
            },
            {
              Header: "CC Charge",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.cc_fee)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(props.row.original?.cc_fee)}
                  </Typography>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "Final Total",
              accessor: (originalRow, rowIndex) => {
                return (
                  strictValidObjectWithKeys(originalRow) &&
                  defaultCurrencyFormat(originalRow?.final_total)
                );
              },
              rightAlign: true,
              Cell: (props) => (
                <Stack>
                  <Typography>
                    {defaultCurrencyFormat(props.row.original?.final_total)}
                  </Typography>
                </Stack>
              ),
              width: 75,
              disableSortBy: true,
            },
            {
              Header: "Extra Charges",
              accessor: "Action",
              Cell: (props) => (
                <>
                  <Tooltip
                    title={
                      strictValidArrayWithLength(
                        props.row.original?.extra_charges
                      ) && "View Extra Charges"
                    }
                  >
                    <Stack>
                      <IconButton
                        onClick={async () => {
                          setExtraCharges(props.row.original?.extra_charges);
                          infoToggle();
                        }}
                        disabled={
                          !strictValidArrayWithLength(
                            props.row.original?.extra_charges
                          )
                        }
                        color="primary"
                        size="medium"
                      >
                        <VisibilityIcon />
                      </IconButton>
                    </Stack>
                  </Tooltip>
                </>
              ),
              width: 70,
              disableSortBy: true,
            },
          ]}
          rowData={Array.isArray(invoice_data) ? invoice_data : []}
        />
      </Grid>
      {extraChargesDialog()}
    </>
  );
};

InvoiceReport.propTypes = {
  callInvoicingApi: PropTypes.func,
  isLoad: PropTypes.bool,
  isLoadInner: PropTypes.bool,
  loadErr: PropTypes.string,
  message: PropTypes.string,
};

InvoiceReport.defaultProps = {
  isLoad: false,
  loadErr: "",
  message: "",
};

const mapStateProps = (state) => {
  return {
    message: state.billing.invoice.message,
    isLoad: state?.billing?.invoiceReport?.isLoad,
    loadErr: state.billing.invoice.loadErr,
    data: state.billing.invoice.data,
    total_invoice: state.billing.invoiceReport.totalRecords,
    corporateAccountFromState: state.billing.invoice.all_corporates_billing,
    isLoadInner: state.billing.invoiceReport.isLoadInner,
    invoice_data: state?.billing?.invoiceReport?.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  callInvoicingApi: (...params) => dispatch(getInvoiceReportList(...params)),
  callCorporateAccountBilling: (...params) =>
    dispatch(getCorporateAccounts(...params)),
  callExcelFromAccountApi: (...params) =>
    dispatch(getExcelInvoiceReport(...params)),
});

export default connect(mapStateProps, mapDispatchToProps)(InvoiceReport);
